import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {TableComponent} from '../../../components/table/table.component';
import {AuthenticatedBaseComponent} from '../../authenticated-base.component';

@Component({
  selector: 'app-patients-login',
  templateUrl: 'patients-login.component.html',
  standalone: true,
  imports: [TableComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientsLogin extends AuthenticatedBaseComponent implements OnInit {
  public ngOnInit() {
    this.titleService.setTitle('authenticated.administration.patients-login.title');
  }
}
